import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsExternalLinkPipe } from './is-external-link.pipe';

@NgModule({
  declarations: [IsExternalLinkPipe],
  imports: [CommonModule],
  exports: [IsExternalLinkPipe],
})
export class IsExternalLinkModule {
}
